/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { AppService } from '@services/app/app.service';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-retry-after-error',
  templateUrl: './retry-after-error.component.html',
  styleUrls: ['./retry-after-error.component.scss']
})
export class RetryAfterErrorComponent implements OnInit {
  /**
   * numero massimo di tentativi
   */
  @Input() maxAttemps: number;

  /**
   * evento emesso alla richiesta di retry
   */
  @Output() retry: EventEmitter<number> = new EventEmitter<number>();

  /**
   * numero di tentativi effettuati
   */
  attemps = 0;

  get maxReached(): boolean {
    return this.attemps >= this.maxAttemps;
  }

  constructor(private appService: AppService) {}

  ngOnInit() {
    if (typeof this.maxAttemps !== 'number') {
      this.maxAttemps =
        this.appService.getConfig().generic.maxAttempsAfterError || 3;
    }
  }

  /**
   * emette evento di retry
   */
  doRetry(): void {
    this.attemps++;
    this.retry.emit(this.attemps);
  }
}
